class MiniCartToggle {
    constructor({
        root = '.js-header-cart',
        overlay = '[data-mini-cart-overlay]',
        toggles = ['[data-cart-quantity]', '.icon-shop'],
    } = {}) {
        this.root = document.querySelector(root);
        if (!this.root) return;

        this.cartUrl = this.root.dataset.cartUrl || '/cart';
        this.breakpoint = parseInt(this.root.dataset.breakpoint, 10) || 1023;
        this.container = this.root.querySelector('.mini-cart');
        this.wrapper = this.root.querySelector('.mini-cart__wrapper');
        this.listWrap = this.root.querySelector('.sp-mini-cart__list-wrap');
        this.list = this.root.querySelector('.sp-mini-cart__list');
        this.overlay = document.querySelector(overlay);
        this.fragmentsUrl = this.resolveFragmentsUrl();
        this.isOpen = false;
        this.closeTimeout = null;
        this.ignoreFocusOut = false;

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.applyState = this.applyState.bind(this);
        this.onEsc = this.onEsc.bind(this);
        this.onToggleClick = this.onToggleClick.bind(this);
        this.scheduleClose = this.scheduleClose.bind(this);
        this.cancelClose = this.cancelClose.bind(this);
        this.updateScrollState = this.updateScrollState.bind(this);
        this.refreshElements = this.refreshElements.bind(this);
        this.refreshFragments = this.refreshFragments.bind(this);
        this.applyFragments = this.applyFragments.bind(this);

        this.mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.root.addEventListener('mouseenter', () => {
            if (this.isDesktop()) {
                this.cancelClose();
                this.open();
            }
        });
        this.root.addEventListener('mouseleave', () => {
            if (this.isDesktop()) this.scheduleClose();
        });
        if (this.wrapper) {
            this.wrapper.addEventListener('mouseenter', () => {
                if (this.isDesktop()) {
                    this.cancelClose();
                    this.open();
                }
            });
            this.wrapper.addEventListener('mouseleave', () => {
                if (this.isDesktop()) this.scheduleClose();
            });
            this.wrapper.addEventListener('pointerdown', () => {
                if (this.isDesktop()) {
                    this.ignoreFocusOut = true;
                    this.cancelClose();
                    this.open();
                    window.setTimeout(() => {
                        this.ignoreFocusOut = false;
                    }, 300);
                }
            });
        }

        this.root.addEventListener('focusin', () => {
            if (this.isDesktop()) this.open();
        });
        this.root.addEventListener('focusout', event => {
            if (this.ignoreFocusOut) return;
            if (
                this.isDesktop() &&
                !this.root.contains(event.relatedTarget) &&
                !(this.wrapper && this.wrapper.contains(event.relatedTarget))
            ) {
                this.close();
            }
        });

        const toggleEls = toggles.flatMap(sel =>
            Array.from(this.root.querySelectorAll(sel))
        );
        toggleEls.forEach(el => el.addEventListener('click', this.onToggleClick));

        document.addEventListener('keydown', this.onEsc);

        if (this.list) {
            this.list.addEventListener('scroll', this.updateScrollState);
        }
        window.addEventListener('resize', this.updateScrollState);

        if (window.jQuery) {
            window.jQuery(document.body).on(
                'wc_fragments_refreshed added_to_cart removed_from_cart',
                (event, fragments = null) => {
                    if (fragments && typeof fragments === 'object') {
                        this.applyFragments(fragments);
                    }
                    this.refreshElements();
                }
            );
        }

    }

    isDesktop() {
        return window.innerWidth > this.breakpoint && this.mqHover.matches;
    }

    onToggleClick(event) {
        if (!this.isDesktop()) {
            event.preventDefault();
            window.location.href = this.cartUrl;
        }
    }

    resolveFragmentsUrl() {
        const params =
            window.wc_cart_fragments_params || window.woocommerce_params || {};
        if (params.wc_ajax_url) {
            return params.wc_ajax_url.replace(
                '%%endpoint%%',
                'get_refreshed_fragments'
            );
        }
        return '/?wc-ajax=get_refreshed_fragments';
    }

    open() {
        this.isOpen = true;
        this.applyState();
    }

    close() {
        this.isOpen = false;
        this.applyState();
    }

    applyState() {
        if (this.wrapper) {
            if (this.isOpen) {
                this.wrapper.classList.remove(
                    'opacity-0',
                    'invisible',
                    'translate-y-2',
                    'pointer-events-none'
                );
                this.wrapper.classList.add(
                    'opacity-100',
                    'visible',
                    'translate-y-0',
                    'pointer-events-auto'
                );
                window.requestAnimationFrame(this.refreshElements);
            } else {
                this.wrapper.classList.add(
                    'opacity-0',
                    'invisible',
                    'translate-y-2',
                    'pointer-events-none'
                );
                this.wrapper.classList.remove(
                    'opacity-100',
                    'visible',
                    'translate-y-0',
                    'pointer-events-auto'
                );
            }
        }

        if (this.overlay) {
            if (this.isOpen) {
                this.overlay.classList.remove('opacity-0', 'pointer-events-none');
                this.overlay.classList.add('opacity-100', 'pointer-events-auto');
            } else {
                this.overlay.classList.add('opacity-0', 'pointer-events-none');
                this.overlay.classList.remove('opacity-100', 'pointer-events-auto');
            }
        }

        this.root.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    }

    scheduleClose() {
        this.cancelClose();
        this.closeTimeout = window.setTimeout(() => {
            this.close();
        }, 200);
    }

    cancelClose() {
        if (this.closeTimeout) {
            window.clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
        }
    }

    updateScrollState() {
        if (!this.list || !this.listWrap) return;
        const hasScroll =
            this.list.scrollHeight > this.list.clientHeight + 1;
        this.list.classList.toggle('has-scroll', hasScroll);
        this.listWrap.classList.toggle('has-scroll', hasScroll);
        const atBottom =
            !hasScroll ||
            this.list.scrollTop + this.list.clientHeight >=
                this.list.scrollHeight - 1;
        this.listWrap.classList.toggle('is-at-bottom', atBottom);
    }

    refreshElements() {
        this.listWrap = this.root.querySelector('.sp-mini-cart__list-wrap');
        this.list = this.root.querySelector('.sp-mini-cart__list');
        if (this.list) {
            this.list.removeEventListener('scroll', this.updateScrollState);
            this.list.addEventListener('scroll', this.updateScrollState);
        }
        this.updateScrollState();
    }

    refreshFragments() {
        if (!this.fragmentsUrl) return;
        fetch(this.fragmentsUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
        })
            .then(response => response.json())
            .then(data => {
                const fragments = data?.fragments;
                if (!fragments) return;
                this.applyFragments(fragments);
                this.refreshElements();
            })
            .catch(() => {});
    }

    applyFragments(fragments) {
        Object.entries(fragments).forEach(([selector, html]) => {
            document.querySelectorAll(selector).forEach(node => {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                const newNode = temp.firstElementChild;
                if (newNode) {
                    if (selector === 'div.widget_shopping_cart_content') {
                        if (node.id === 'mini-cart-wrapper') {
                            node.innerHTML = newNode.innerHTML;
                            return;
                        }
                        newNode.id = 'mini-cart-wrapper';
                        node.replaceWith(newNode);
                        return;
                    }
                    if (node.id === 'mini-cart-wrapper') {
                        node.innerHTML = newNode.innerHTML;
                        return;
                    }
                    node.replaceWith(newNode);
                }
            });
        });
    }


    onEsc(event) {
        if (event.key === 'Escape') this.close();
    }
}

new MiniCartToggle();
